export default {"src":"/_next/static/image/public/images/ic_call_dark_green.d3e3bc702c17fabad66cc2f49559467b.svg","height":30,"width":31};